import React from 'react'
// import { Navigate } from "react-router-dom";
import { Redirect } from 'react-router-dom/cjs/react-router-dom';

const ProtectedRoute = ({ isAuthenticated, children }) => {
//   return isAuthenticated ? children : <Navigate to="/login" replace />
  return isAuthenticated ? children : <Redirect to="/login" replace />
}

export default ProtectedRoute